import React from "react";
import { Redirect } from "react-router-dom";
import { Action, Store } from "@byhuz/huz-ui-state";
import axios from "axios";
import {useSelector} from "react-redux";
import Spinner from "components/Alert/Spinner";

export default function SecuredContainer({children}){
    
    const [isChecked,setIsChecked]=React.useState(false);
    const is_loggedIn=useSelector(state=>state.default?.loggedIn||false);

    // Session Check
    const sessionCheck = () => {
        console.log("Session Check");
        axios.get('userinfo')
        .then(res=>{
          if (parseInt(res.data.code)===400) {
            Store.dispatch(Action.update("loggedIn", false));
            Store.dispatch(Action.update("user"));
            return;
          }
    
          if (parseInt(res.data.code)===404) {            
            Store.dispatch(Action.update("loggedIn", false));
            return;
          }
    
          if (parseInt(res.data.code)===200) {            
            Store.dispatch(Action.update("loggedIn", true));
            Store.dispatch(Action.update("user", res.data.payload));
          }
        })
        .catch(err=>{
            Store.dispatch(Action.update("loggedIn", false));
            Store.dispatch(Action.update("user"));
            console.log(err);
        }).finally(()=>{
            setIsChecked(true);
        });
      }

      React.useEffect(()=>{
          sessionCheck();
      },[]);

      
    return (
        !isChecked? <Spinner show="true" />: 
        is_loggedIn? <div>{children}</div>:<Redirect to="/auth/login" />
    )
}